export enum PickListTranslationKey {
    AVAILABLE_ITEMS = "pickList.availableItems",
    ASSIGNED_ITEMS = "pickList.assignedItems",
    ITEMS_ASSIGNMENT = "pickList.itemsAssignment",
    ADD = "pickList.add",
    REMOVE = "pickList.remove",
    CHANGES_NOT_SUCCESSFULL = "pickList.changesNotSuccessful",
}
